import { ToastType } from 'react-toastify';

import { getObjectSelectedClient } from '@domain/object-selected';
import { showToast } from '../../../shared/components/messages-and-errors/ToastsNotifications';
import { createMiddleware } from '../../../shared/redux';

import {
    WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_SUCCESS,
    WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_ERROR,
    WOOCOMMERCE_GET_DATA_REQUEST_ERROR,
} from './woocommerce.state';

import { API_FAIL_DEFAULT_OP_MESSAGE, API_SUCCESS_OP_MESSAGE } from './woocommerce.constants';
import { getActiveIntegrationsAction } from '../integrations-list/integrations-list.state';
import { getErrorKey } from '../../../shared/utils/errors';

const defaultToastProps = {
    autoClose: 2000, toastId: 'woocommerce-toast', height: 300,
};

// @TODO: create a better way to define toasts in middleware
export const woocommerceMiddleware = createMiddleware({
    [WOOCOMMERCE_GET_DATA_REQUEST_ERROR]: (_, action) => {
        const message = getErrorKey(action.payload.response, API_FAIL_DEFAULT_OP_MESSAGE);

        showToast(message, ToastType.ERROR, {
            ...defaultToastProps,
            toastId: 'woocommerce-get-data-error',
        });
    },
    [WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_ERROR]: (_, action) => {
        const message = getErrorKey(action.payload.response, API_FAIL_DEFAULT_OP_MESSAGE);

        showToast(message, ToastType.ERROR, {
            ...defaultToastProps,
            toastId: 'woocommerce-save-error',
        });
    },
    [WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_SUCCESS]: (state) => {
        const { id } = getObjectSelectedClient(state);

        showToast(API_SUCCESS_OP_MESSAGE, ToastType.SUCCESS, defaultToastProps);

        return getActiveIntegrationsAction(id);
    },
});
